<div [formGroup]="form">
	<div class="pv-input">
		@if (label) {
			<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
				{{ label }}
			</ic-label>
		}

		<div class="border">
			@if (icon) {
				<i aria-hidden="true" [class.disabled]="form.disabled" [ngClass]="[icon, 'icon']"></i>
			}
			<input
				formControlName="text"
				icAutocompletionPlace
				[class]="inputClass"
				[placeholder]="placeholder"
				[type]="type"
				(blur)="onBlur()"
				(selectedPlace)="placeChangedCallback($event)"
			/>

			@if (!form.get("text").value || form.disabled) {
				<i aria-hidden="true" class="caret fa fa-search" [class.disabled]="form.disabled"></i>
			} @else {
				<i aria-hidden="true" class="caret fa fa-times" (click)="clear()"></i>
			}
		</div>
		@if (form.hasError("noCountryCode")) {
			<p class="errors">{{ "error.noCountryCode" | translate }}</p>
		}
		<ng-content select=".errors" />
	</div>
</div>
